<button mat-icon-button aria-label="Присутствовал на уроке или нет"
  class="absent-component__button"
  (click)="checkBoxAbsentClicked()">
  <mat-icon class="absent-component__button__icon" [class.active-icon]="!isAbsent">fiber_manual_record</mat-icon>
</button>
